export const GRID_SIZE = 8;

export const GRID_WIDTH = GRID_SIZE;
export const GRID_HEIGHT = GRID_SIZE;

export const CELL_SIZE = 50;
export const HOLDER_SCALING = 0.9;